import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CompEmailItem, CompEmailTempReadByTenantIdRequestDTO } from 'src/app/AdvERP/companies/company-email-templates/company-email-templates.interface';
import { EmailService } from 'src/app/AdvERP/companies/company-email-templates/company-email-templates.service';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { compEmailTempVarReadByTemplateIdRequestDTO, compEmailVarResponseItem } from 'src/app/AdvERP/companies/company-email-templates/company-email-templates-variables.interface';
import { EmailVariableService } from 'src/app/AdvERP/companies/company-email-templates/company-email-templates-variables.service';
import { NotificationMaster_CreateRequestDTO } from '../history/history.interface';
import { HistoryService } from '../history/history.service';
import { DomSanitizer } from '@angular/platform-browser';
import { nonZeroValidator } from 'src/app/Shared/validators/nonZeroValidator';
import { EmailConfigDTO, EmailConfigReadAllRequestDTO } from '../email-config/email-config.interface';
import { EmailConfigService } from '../email-config/email-config.service';
import { DocumentMasterDTO } from 'src/app/Common/DocumentMasterService/documentmaster.interface';
import { DocumentMasterService } from 'src/app/Common/DocumentMasterService/document-master.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-send-email',
  templateUrl: './send-email.component.html',
  styleUrls: ['./send-email.component.css']
})
export class SendEmailComponent {
  
  @Input() StandAloneButton: Boolean = false;
  @Input() StandAloneTemplateData!: CompEmailItem
  @Input() StandAloneEmailTo! : string 

  // Properties
  isLoading: Boolean = false
  isUniversalEditing: Boolean = false
  
  // Items
  EmailList: CompEmailItem[] = [];
  emailVariableList: compEmailVarResponseItem[] = []
  attachmentFilePaths: string[] = [];

  // Services 
  EmailService = inject(EmailService)
  public modalService = inject(NgbModal)
  User = inject(UserLoginService).User();
  historyService = inject(HistoryService)
  sanitizer = inject(DomSanitizer)
  EmailVariableService = inject(EmailVariableService)
  DocumentMasterService = inject(DocumentMasterService);


  addSendModel!: NgbModalRef;
  @ViewChild('SendEmailForm', { static: false }) SendEmailForm!: ElementRef;


  // Forms
  EmailForm = new FormGroup({
    templateId: new FormControl(0),

    tName: new FormControl(''),
    tDesc: new FormControl(''),
    moduleName: new FormControl(''),
    subModuleName: new FormControl(''),

    dataSourceType: new FormControl(''),
    dataSourceDefination: new FormControl(''),
    postDataSourceType: new FormControl(''),
    postDataSourceDefination: new FormControl(''),

    emailTO: new FormControl('', [Validators.required]),
    ccTo: new FormControl(''),
    bccTo: new FormControl(''),
    aSubject: new FormControl(''),
    attachments: new FormControl([]),
    file: new FormControl(''),      
    fileName: new FormControl(''),  
    aBody: new FormControl(''),
    emailConfigId: new FormControl(0,[Validators.required, nonZeroValidator()]),
    DBConnId: new FormControl(0),

    otherDetail1: new FormControl(''),
    otherDetail2: new FormControl(''),
    otherDetail3: new FormControl(''),
    otherDetail4: new FormControl(''),
    otherDetail5: new FormControl(''),
    otherDetail6: new FormControl(''),

    emailVariables: new FormArray([])

  });
  emailConfigList: EmailConfigDTO[] = [];

  emailConfigService = inject(EmailConfigService)
  ngOnInit() {
    this.GetAllEmailTemplate()
    this.getEmailConfigList()
  }


  getEmailConfigList() {
    let data: EmailConfigReadAllRequestDTO = {
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: 0
    }

    this.emailConfigService.EmailConfig_readAll(data).subscribe(res => {
      console.log(res);
      
      this.emailConfigList = res.items
    })
  }

  openModal(data: CompEmailItem) { 

    this.EmailForm.reset()
    this.getEmailTemplateVariablesLists(data.templateId)
    this.EmailForm.patchValue({
      templateId: data.templateId,
      aBody: data.aBody,
      tName: data.tName,
      aSubject: data.aSubject,
      emailConfigId: data.emailConfigId,
      DBConnId: data.DBConnId,
      postDataSourceDefination: data.postDataSourceDefination,
      postDataSourceType: data.postDataSourceType,
      emailTO: this.StandAloneEmailTo ?? ""
    })
    this.addSendModel = this.modalService.open(this.SendEmailForm, { size: "xl" });

  }

  GetAllEmailTemplate() {
    this.isLoading = true
    let data: CompEmailTempReadByTenantIdRequestDTO = {
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      moduleName: 'AdvCRM'
    }
    this.EmailService.CompanyEmailTemplate_ReadByTenantId(data).subscribe({
      next: (res) => {
        this.EmailList = res.items
        this.isLoading = false
      },
      error: (err) => {

      }
    })

  }

  onSubmitAction(): void {

    this.EmailForm.markAllAsTouched();
    if (this.EmailForm.invalid) {
      return;
    }

    const data: NotificationMaster_CreateRequestDTO = {
      alertConfigId: Number(this.EmailForm.value.emailConfigId),
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: 1,
      nType: 'Email',
      nSubject: this.EmailForm.value.aSubject ?? "",
      nContent: this.EmailForm.value.aBody ?? "",
      nTo: this.EmailForm.value.emailTO ?? " ",
      nCc: this.EmailForm.value.ccTo ?? " ",
      nBcc: this.EmailForm.value.bccTo ?? " ",
      nStatus: 'Pending',
      remarks: '',
      scheduledDate: new Date().toISOString(),
      attachmentPath: this.attachmentFilePaths.join(','),
      retryCount: 0,
      retryDate: null,
      postSendDataSourceType: this.EmailForm.value.postDataSourceType ?? "",
      postSendDataSourceDef: this.EmailForm.value.postDataSourceDefination ?? "",
      dbConnId: this.EmailForm.value.DBConnId ?? 0,
      actionUser: this.User.userId.toString()
    };

    this.historyService.notificationMaster_Create(data).subscribe({
      next: () => this.addSendModel.close()
    });
  }


  getEmailTemplateVariablesLists(tempId: number) {
    const data: compEmailTempVarReadByTemplateIdRequestDTO = {
      templateId: tempId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId
    }
    this.EmailVariableService.CompanyEmailTemplateVariable_ReadByTemplateId(data).subscribe({
      next: (response) => { this.emailVariableList = response.items; },
      error: (error) => { console.error("Failed to fetch EMail Varibale Data", error) }
    });
  }


  onVariableInput(variable: compEmailVarResponseItem, event: any) {
    // Update the variable value
    variable.varValue = event.target.value;

    let replaced_value = event.target.value
    if (replaced_value === "") replaced_value = variable.varInstance

    const og = this.EmailList.find(
      t => t.templateId === this.EmailForm.value.templateId
    )?.aBody || '';

    // Start from the original template body
    let originalBody = og
    originalBody = originalBody.replaceAll(variable.varInstance, replaced_value)


    // Update the form control
    this.EmailForm.patchValue({
      aBody: originalBody
    });
  }

   onAttachmentSelected(event: any) {
      const file: File = event.target.files[0];
  
      if (file) {
        const formData = new FormData();
        formData.append('File', file, file.name);
        formData.append('TenantId', this.User.companyId.toString());
        formData.append('TenantBranchId', this.User.loggedInBranchId.toString());
        formData.append('SoftwareId', environment.SoftwareId);
  
        this.DocumentMasterService.DocumentMaster_Upload(formData)
          .subscribe({
            next: (res: DocumentMasterDTO) => {
  
              if (!res.url) {
                console.warn("No URL returned in response!");
              } else {
                // Add to attachment paths
                this.attachmentFilePaths.push(res.url);
              }
  
              // Patch form values for convenience
              this.EmailForm.patchValue({
                file: res.url ?? '',
                fileName: res.fileName ?? ''
              });
            },
            error: (err: any) => {
              console.error("File upload failed:", err);
            }
          });
      } else {
        console.warn("No file selected");
      }
    }






}